import * as yup from "yup";

export type FormValues = {
  name: string;
};

export const validationSchema = yup.object({
  name: yup.string().required("Вкажіть Назву Інтеграції"),
});
